export default "skymp5-front/1e9847ef902c2160f0627bc8b5d48e5a.wav";